module.exports = __webpack_public_path__ + "img/email.6f63d1a3.png";